import { FormlyFieldConfig } from '@ngx-formly/core';
import {Meta} from "../models";

/**
 * Interface for the 'Forms' data
 */
export interface FormTemplateRenderModel {
  id: string | number; // Primary ID
  title: string;
  code: string;
  allowAnonymous: boolean;
  sections: FormRenderModel[];
  theme?: ThemeRenderModel;
}

export interface ThemeRenderModel {
  backgroundUrl: string;
  logoUrl: string;
  code: string;
  name: string;
  styles: string;
  logoStyles: string;
}

export interface FormDataModel {
  uid: string;
  formCode: string;
  formData: unknown;
}

export interface FormDataOutput {
  id: string;
  userName: string;
  status: string;
  uid: string;
  code: string;
  dateLastUpdate: string;
  data: Record<string, string>;
}

export interface FormsDataResponse {
  meta: Meta;
  data: FormDataOutput[];
}

export interface FormTemplateSettingsModel {
  title: string;
  code: string;
  isVisible: boolean;
  allowAnonymous: boolean;
}

export interface FormRenderModel {
  id: number;
  label?: string;
  fields: FormlyFieldConfig[];
}

export interface SelectFieldFilter {
  section: string;
  field: string;
  value: string;
}

export interface SelectFieldOption {
  label: string;
  value: string;
  tooltip: string;
}

export interface SelectFieldOptionsResult {
  section: string;
  field: string;
  options: SelectFieldOption[]
}

export interface CountryPostCodeValidationRule {
  country: string;
  validationString: string;
  infoMessage: string;
  errorMessage: string;
}

export class SubmissionStatusIcon {
  private elem: HTMLDsTagElement | null = null;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  init(params: any) {
    this.elem = document.createElement('ds-tag');
    this.elem.size = 'compact';
    this.elem.type = params.getValue() == 'Submitted' ? 'success' :
      params.getValue() == 'NotSubmitted' ? 'warning' :
      params.getValue() == 'SubmittedWithWarning' ? 'warning' :
      params.getValue() == 'OngoingSubmissionFromBackoffice' ? 'primary' : 'danger';

    this.elem.textContent = params.getValue() == 'Submitted' ? 'Submitted' :
      params.getValue() == 'NotSubmitted' ? 'Not Submitted' :
      params.getValue() == 'SubmittedWithWarning' ? 'Submitted with warning' :
      params.getValue() == 'OngoingSubmissionFromBackoffice' ? 'On-going submission from back-office' : 'Unknown';
  }

  getGui() {
    return this.elem;
  }
}

export interface ExportDataModel {
  uri: string;
  error: string;
  status: ExportDataStatus;
}

export enum ExportDataStatus {
  None,
  Requested,
  GettingData,
  BuildingReport,
  Completed,
}

export interface FormTemplateTitle {
  title: string;
}
